import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const ConfirmationPopup = ({
  show,
  onClose,
  onCancel,
  onAccept,
  question,
  title,
  acceptText,
  cancelText,
  showDeleteButton,
}) => {
  return (
    show && (
      <div
        className="fixed top-0 left-0 w-full h-full"
        style={{ zIndex: "200" }}
      >
        <div
          className="absolute top-0 left-0 w-full h-full bg-black/30"
          onClick={onClose}
        ></div>
        <div className="max-w-[450px] h-full flex flex-col justify-center mx-auto p-6">
          <div className="confirmation-card rounded-xl bg-white p-6 relative z-10">
            <div className="text-center">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                size="2x"
                className="bg-red-100 text-red-700 rounded-full p-2"
              />
              <h1 className="mt-3 text-md font-bold text-black">{title}</h1>
              <p className="text-sm font-medium mt-3">{question}</p>
            </div>

            <div className="my-3">
              <button
                className="flex-1 w-full my-2 bg-[#C81E1E] text-white py-2 rounded "
                onClick={onAccept}
                disabled={!showDeleteButton}
              >
                {acceptText}
              </button>

              <button
                type="button"
                className="flex-1 w-full mt-2 border border-gray-300 py-2 rounded"
                onClick={onCancel}
              >
                {cancelText}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ConfirmationPopup;
